import React from 'react'
import { getModuleHeaderWarningText } from '@/modules/settings/services/moduleHeaderWarningSettingsService'

export function useAnalysisHeaderWarningText() {
  const [text, setText] = React.useState<string | null>(null)

  React.useEffect(() => {
    let mounted = true
    ;(async () => {
      try {
        const value = await getModuleHeaderWarningText('analysis')
        if (!mounted) return
        setText(value)
      } catch {
        if (!mounted) return
        setText('')
      }
    })()
    return () => {
      mounted = false
    }
  }, [])

  return text
}
